import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Input } from 'gin-and-tonic/common/input/Input'
import { Button } from 'gin-and-tonic/common/button/Button'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { ErrorMessage } from 'gin-and-tonic/common/error-message/ErrorMessage'
import { usePublicRequestEmailVerificationForm } from 'domains/public/components/request-email-verification/utils/publicRequestEmailVerification.hooks'
import { PublicLayout } from 'domains/public/components/layout/PublicLayout'
import { ReCaptchaCheckBox } from 'gin-and-tonic/containers/re-captcha-check-box/ReCaptchaCheckBox'

const formStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  width: 240,
  justifyItems: 'flex-start',
})

export const PublicRequestEmailVerification: FunctionComponent = () => {
  const {
    requestVerificationEmailSuccess,
    disableFormFields,
    formErrorMessageId,
    emailFieldRef,
    setReCaptchaResetHandler,
    registerReCaptchaTokenField,
    setReCaptchaTokenValue,
    onSubmit,
    emailErrorMessageId,
    reCaptchaTokenErrorMessageId,
  } = usePublicRequestEmailVerificationForm()

  if (requestVerificationEmailSuccess) {
    return <DashRedirect push toRoute="public-pending-email-verification" />
  }

  return (
    <PublicLayout headerMessageId="public.requestEmailVerification.header">
      <form css={formStyles} onSubmit={onSubmit}>
        <Input
          name="email"
          disabled={disableFormFields}
          errorMessageId={emailErrorMessageId}
          placeholderMessageId="public.requestEmailVerification.form.fields.email.placeholder"
          ref={emailFieldRef}
          data-testid="public-request-email-verification-form-field-email"
        />
        <ReCaptchaCheckBox
          setResetHandler={setReCaptchaResetHandler}
          action="public-request-email-verification-form-re-captcha"
          onLoad={registerReCaptchaTokenField}
          onChange={setReCaptchaTokenValue}
          errorMessageId={reCaptchaTokenErrorMessageId}
        />
        <ErrorMessage
          collapse={false}
          messageId={formErrorMessageId}
          data-testid="public-request-email-verification-form-error-message"
        />
        <Button
          disabled={disableFormFields}
          type="submit"
          messageId="public.requestEmailVerification.form.submit"
          data-testid="public-request-email-verification-form-submit"
        />
      </form>
    </PublicLayout>
  )
}
